'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TaskQueue = exports.Task = exports.Error = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _message = require('./message');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Error = function Error(code, msg) {
  _classCallCheck(this, Error);

  this.code = code;
  this.msg = msg;
};

var TaskQueue = function () {
  function TaskQueue(execr, handler) {
    _classCallCheck(this, TaskQueue);

    if (typeof execr == 'undefined') {
      return;
    }
    this.execr = execr;
    this.handler = handler;
    this.seq = 1;
    this.task_map = {};
  }

  _createClass(TaskQueue, [{
    key: 'push',
    value: function push(task) {
      task.queue = this;
      if (this.seq > 1000000) {
        this.seq = 0;
      }
      this.seq = this.seq + 2;
      task.seq = this.seq;
      task.msg.Seq = this.seq;

      this.execr(task);
      if (typeof task.callback === 'function') {
        this.task_map[this.seq] = task;
      }

      task.wait();
    }
  }, {
    key: 'handleMsg',
    value: function handleMsg(msg) {
      if (!msg instanceof _message.Message) {
        return;
      }
      var task = this.task_map[msg.Seq];
      if (typeof task !== 'undefined') {
        task.onResponse(msg);
      } else {
        this.handler(msg);
      }
    }
  }, {
    key: 'clear',
    value: function clear() {

      // this.task_map.clear()

      var self = this;
      Object.keys(self.task_map).map(function (key) {
        var task = self.task_map[key];
        task.cancel();
      });
    }
  }]);

  return TaskQueue;
}();

var Task = function () {
  function Task(msg, callback) {
    _classCallCheck(this, Task);

    this.msg = msg;
    this.callback = callback;
    this.done = false;

    this.state = 0;
  }

  _createClass(Task, [{
    key: 'wait',
    value: function wait() {
      var self = this;

      if (typeof this.callback === 'undefined') {
        self.done = true;
        delete self.queue.task_map[self.msg.seq];
        return;
      }

      setTimeout(function () {
        if (!self.done) {

          self.callback(undefined, new Error(408, '超时'));

          delete self.queue.task_map[self.msg.seq];
        }
      }, 10000);
    }
  }, {
    key: 'onResponse',
    value: function onResponse(msg) {
      if (typeof this.callback == 'undefined') {
        delete this.queue.task_map[this.msg.seq];
        return;
      }
      this.done = true;
      this.callback(msg, undefined);
      delete this.queue.task_map[this.msg.seq];
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.done = true;
    }
  }]);

  return Task;
}();

exports.Error = Error;
exports.Task = Task;
exports.TaskQueue = TaskQueue;
//# sourceMappingURL=task.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ciim_sdk@3.0.8@ciim_sdk/dist/im/task.js
// module id = UNeI
// module chunks = 0